import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import { LayoutProvider } from './contexts/LayoutContext';
import { UserProvider } from './contexts/UserContext';
import { useSecurityMonitor } from './hooks/useSecurityMonitor';
import Login from './pages/Login/Login';
import Home from './pages/Home/Home';
import UserManagement from './pages/Users/UserManagement';
import UserFormPage from './pages/Users/UserFormPage';
import { IntegrationManagement } from './pages/Integrations';
import EventManagement from './pages/Events/EventManagement';
import EventFormPage from './pages/Events/EventFormPage';
import MarkerManagement from './pages/Markers/MarkerManagement';
import ProjectManagement from './pages/Projects/ProjectManagement';
import ProjectFormPage from './pages/Projects/ProjectFormPage';
import Diagnostico from './pages/Diagnostico/Diagnostico';
import Dashboard from './pages/Dashboard/Dashboard';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword';
import ResetPassword from './pages/ForgotPassword/ResetPassword';
import Invitation from './pages/Invitation/Invitation';
import NotFound from './pages/NotFound/NotFound';
import { MainLayout } from './components/MainLayout';
import PrivateRoute from './components/PrivateRoute';
import CompanyOnlyRoute from './components/CompanyOnlyRoute';
import './App.css';


function App() {
  // Monitor de segurança (apenas em produção)
  useSecurityMonitor({
    detectDevTools: true,
    detectMultipleWindows: true,
    detectCopyPaste: false, // Desabilitado para não incomodar usuários legítimos
  });

  return (
    <FluentProvider theme={webLightTheme}>
      <Router future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
        <UserProvider>
          <LayoutProvider>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/set-password" element={<Invitation />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/home" element={<PrivateRoute><MainLayout><Home /></MainLayout></PrivateRoute>} />
              <Route 
                path="/users" 
                element={
                  <PrivateRoute>
                    <CompanyOnlyRoute>
                      <MainLayout><UserManagement /></MainLayout>
                    </CompanyOnlyRoute>
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/users/new" 
                element={
                  <PrivateRoute>
                    <CompanyOnlyRoute>
                      <MainLayout><UserFormPage /></MainLayout>
                    </CompanyOnlyRoute>
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/users/edit" 
                element={
                  <PrivateRoute>
                    <CompanyOnlyRoute>
                      <MainLayout><UserFormPage /></MainLayout>
                    </CompanyOnlyRoute>
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/integrations" 
                element={
                  <PrivateRoute>
                    <CompanyOnlyRoute>
                      <MainLayout><IntegrationManagement /></MainLayout>
                    </CompanyOnlyRoute>
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/events" 
                element={
                  <PrivateRoute>
                    <CompanyOnlyRoute>
                      <MainLayout><EventManagement /></MainLayout>
                    </CompanyOnlyRoute>
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/events/new" 
                element={
                  <PrivateRoute>
                    <CompanyOnlyRoute>
                      <MainLayout><EventFormPage /></MainLayout>
                    </CompanyOnlyRoute>
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/events/edit" 
                element={
                  <PrivateRoute>
                    <CompanyOnlyRoute>
                      <MainLayout><EventFormPage /></MainLayout>
                    </CompanyOnlyRoute>
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/markers" 
                element={
                  <PrivateRoute>
                    <CompanyOnlyRoute>
                      <MainLayout><MarkerManagement /></MainLayout>
                    </CompanyOnlyRoute>
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/projects" 
                element={
                  <PrivateRoute>
                      <MainLayout><ProjectManagement /></MainLayout>
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/projects/new" 
                element={
                  <PrivateRoute>
                      <MainLayout><ProjectFormPage /></MainLayout>
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/projects/edit" 
                element={
                  <PrivateRoute>
                      <MainLayout><ProjectFormPage /></MainLayout>
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/diagnostico" 
                element={
                  <PrivateRoute>
                      <MainLayout><Diagnostico /></MainLayout>
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/dashboard" 
                element={
                  <PrivateRoute>
                      <MainLayout><Dashboard /></MainLayout>                   
                  </PrivateRoute>
                } 
              />
              <Route path="/" element={<Navigate to="/dashboard" />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </LayoutProvider>
        </UserProvider>
      </Router>
    </FluentProvider>
  );
}

export default App;
